import axios from 'axios';
import { API_RESULT_CD, CommonResult, createApiRequestUrl, OK } from '../Common';
import { API_EXCEPTION_MSG } from '../../Common';

const URL = createApiRequestUrl('pcmCdNm');

export interface PcmCdNmGetApiRequest {
  displayItemId: string;
  pcmCd: string;
  targetDate: string;
}

export interface PcmCdNmApiResponse {
  pcmCdNm?: string;
  result: CommonResult;
}

export interface PcmCdNmApiResponseErrorResponse {
  pcmCdNm: string;
  result: CommonResult;
}

export async function pcmCdNmApi(request: PcmCdNmGetApiRequest): Promise<PcmCdNmApiResponse> {
  // 日付変換: YYYY-MM-DD形式をYYYYMMDD形式に変換
  let targetDate = '';
  try {
    const parsedDate = new Date(request.targetDate);
    // 有効な日付か確認
    if (!isNaN(parsedDate.getTime())) {
      const year = parsedDate.getFullYear();
      const month = String(parsedDate.getMonth() + 1).padStart(2, '0');
      const day = String(parsedDate.getDate()).padStart(2, '0');
      targetDate = `${year}${month}${day}`;
    }
  } catch (error) {
    console.error('Date parsing error:', error);
  }

  try {
    const headers = {
      'Content-Type': 'application/json',
    };
    const response = await axios.get<PcmCdNmApiResponse>(
      `${URL}?displayItemId=${request.displayItemId}&pcmCd=${request.pcmCd}&targetDate=${targetDate}`,
      {
        headers,
      },
    );
    const data = response.data;
    const status = response.status;
    if (status === OK.status) {
      return data;
    } else {
      throw response;
    }
  } catch (error) {
    return {
      result: {
        jobDateTime: '',
        resultCd: '9999',
        resultMessageDtoList: [
          {
            resultMessageCd: API_RESULT_CD.ERROR,
            resultMessage: `${API_EXCEPTION_MSG}`,
          },
        ],
      },
    };
  }
}
